import { useEffect } from 'react';

const useDynamicInputWidth = (
  refs,
  items,
  getText = (item) => item.productName
) => {
  useEffect(() => {
    items.forEach((item, index) => {
      const input = refs.current[index];
      if (input) {
        const span = document.createElement('span');
        span.style.visibility = 'hidden';
        span.style.position = 'absolute';
        span.style.font = getComputedStyle(input).font;
        span.textContent = getText(item) || '';
        document.body.appendChild(span);

        const calculatedWidth = span.offsetWidth + 10; // Add padding
        input.style.width = `${Math.max(calculatedWidth, 100)}px`; // Minimum 100px

        document.body.removeChild(span);
      }
    });
  }, [items, refs, getText]);
};

export default useDynamicInputWidth;
